import BottomNavigation from "components/BottomNavigation"
import { RadioField, SwitchInputField, TextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row, Table } from "reactstrap"
import { Field, formValueSelector, isDirty, reset } from "redux-form"
import { updateInboxSetup, updateListScreenSetup } from "store/actions"
import PhonePreview from "./phonePreview"
import { required } from "./utils"

const BottomMenuTab = ({
  formValues,
  inboxSetup,
  updateInboxSetup,
  isDirty,
  listScreenSetup,
  resetForm,
  updateListScreenSetup,
  tabIsActive,
  vendorConfig,
  handleBack,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)
  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  const convertBool = boolValue => {
    return boolValue == "true" || boolValue == 1 || boolValue == true ? 1 : 0
  }

  const onSave = () => {
    updateListScreenSetup({
      values: {
        ...listScreenSetup,
        codes_text: formValues?.codesText,
        contact_us_text: formValues?.contactUsText,
        inbox_text: formValues?.notificationsText,
        my_events_text: formValues?.listText,
        private_message_text: formValues?.privateMessageText,
        user_list_text: formValues?.userListText,
        news_feed_text: formValues?.newsFeedText,
      },
      clientSetup: {
        ...vendorConfig,
        app_user_list: convertBool(formValues?.userListToggle),
        contact_us: convertBool(formValues?.contactUsToggle),
        app_wide_private_message: convertBool(formValues?.inboxToggle),
        qr_text_code: convertBool(formValues?.codesToggle),
        news_feed_enabled: convertBool(formValues?.newsFeedToggle),
      },
    })
  }

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>Bottom Menu</h4>
            </CardHeader>
            <CardBody>
              <Table striped responsive style={{ maxWidth: "fit-content" }}>
                <tbody>
                  <tr>
                    <th scope="row">
                      <Row className="mt-2">
                        <Col
                          style={{ width: "200px", minWidth: "fit-content" }}
                        >
                          <i
                            className="mdi mdi-ballot-outline font-size-24 me-1"
                            style={{
                              verticalAlign: "middle",
                            }}
                          />
                          <label style={{ fontSize: "14px" }}>
                            Experience List:{" "}
                          </label>
                        </Col>
                      </Row>
                    </th>
                    <td></td>
                    <td>
                      <Row className="mt-1">
                        <Col
                          className="mt-2"
                          style={{ width: "120px", minWidth: "fit-content" }}
                        >
                          Screen Name:
                        </Col>
                        <Col
                          style={{ width: "150px", minWidth: "fit-content" }}
                        >
                          <Field
                            name="listText"
                            component={TextField}
                            validate={[required]}
                          />
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <Row className="mt-2">
                        <Col
                          style={{ width: "200px", minWidth: "fit-content" }}
                        >
                          <i
                            className="bx bx-file font-size-24 me-1"
                            style={{
                              verticalAlign: "middle",
                            }}
                          />
                          <label style={{ fontSize: "14px" }}>News Feed:</label>
                        </Col>
                      </Row>
                    </th>
                    <td>
                      <Field
                        name="newsFeedToggle"
                        component={SwitchInputField}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#2ECC71"
                        offColor="#E74C3C"
                        height={20}
                        width={40}
                        handleDiameter={18}
                      />
                    </td>
                    <td>
                      <Row className="mt-1">
                        <Col
                          className="mt-2"
                          style={{ width: "120px", minWidth: "fit-content" }}
                        >
                          Screen Name:
                        </Col>
                        <Col
                          style={{ width: "150px", minWidth: "fit-content" }}
                        >
                          <Field
                            name="newsFeedText"
                            component={TextField}
                            validate={[required]}
                          />
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <Row className="mt-2">
                        <Col>
                          <i
                            className="mdi mdi-account-multiple font-size-24 me-1"
                            style={{ verticalAlign: "middle" }}
                          />
                          <label style={{ fontSize: "14px" }}>User List:</label>
                        </Col>
                      </Row>
                    </th>
                    <td style={{ width: "90px", minWidth: "fit-content" }}>
                      <Field
                        name="userListToggle"
                        component={SwitchInputField}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#2ECC71"
                        offColor="#E74C3C"
                        height={20}
                        width={40}
                        handleDiameter={18}
                      />
                    </td>
                    <td>
                      <Row className="mt-2">
                        <Col className="mt-2">Screen Name:</Col>
                        <Col xs="auto">
                          <Field
                            name="userListText"
                            component={TextField}
                            validate={[required]}
                          />
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <Row className="mt-2">
                        <Col>
                          <i
                            className="mdi mdi-contacts font-size-24 me-1"
                            style={{ verticalAlign: "middle" }}
                          />
                          <label style={{ fontSize: "14px" }}>
                            Contact Us:
                          </label>
                        </Col>
                      </Row>
                    </th>
                    <td>
                      <Field
                        name="contactUsToggle"
                        component={SwitchInputField}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#2ECC71"
                        offColor="#E74C3C"
                        height={20}
                        width={40}
                        handleDiameter={18}
                      />
                    </td>
                    <td>
                      <Row className="mt-2">
                        <Col className="mt-2">Screen Name:</Col>
                        <Col xs="auto">
                          <Field
                            name="contactUsText"
                            component={TextField}
                            validate={[required]}
                          />
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <Row className="mt-2">
                        <Col>
                          <i
                            className="mdi mdi-qrcode font-size-24 me-1"
                            style={{ verticalAlign: "middle" }}
                          />
                          <label style={{ fontSize: "14px" }}>
                            Experience Codes:{" "}
                          </label>
                        </Col>
                      </Row>
                    </th>
                    <td>
                      <Field
                        name="codesToggle"
                        component={SwitchInputField}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#2ECC71"
                        offColor="#E74C3C"
                        height={20}
                        width={40}
                        handleDiameter={18}
                      />
                    </td>
                    <td>
                      <Row className="mt-2">
                        <Col className="mt-2">Screen Name:</Col>
                        <Col xs="auto">
                          <Field
                            name="codesText"
                            component={TextField}
                            validate={[required]}
                          />
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" style={{ borderBottom: "none" }}>
                      <Row className="mt-2">
                        <Col>
                          <i
                            className="bx bx-conversation font-size-24 me-1"
                            style={{ verticalAlign: "middle" }}
                          />
                          <label style={{ fontSize: "14px" }}>Messages: </label>
                        </Col>
                      </Row>
                    </th>
                    <td style={{ borderBottom: "none" }}>
                      <Field
                        name="inboxToggle"
                        component={SwitchInputField}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#2ECC71"
                        offColor="#E74C3C"
                        height={20}
                        width={40}
                        handleDiameter={18}
                      />
                    </td>
                    <td style={{ borderBottom: "none" }}>
                      <Row className="mt-2">
                        <Col className="mt-2">Screen Name:</Col>
                        <Col xs="auto">
                          <Field
                            name="privateMessageText"
                            component={TextField}
                            validate={[required]}
                          />
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td colSpan={3}>
                      <Row className="ms-3">
                        <Col xs="auto" className="mt-1">
                          Inbox Style:
                        </Col>
                        <Col xs="auto" className="my-1">
                          <Field
                            name="template"
                            type="radio"
                            component={RadioField}
                            label="Classic Chat"
                            value="1"
                            onChange={(event, value) =>
                              updateInboxSetup({
                                ...inboxSetup,
                                template_id: value,
                              })
                            }
                          />
                        </Col>
                        <Col xs="auto" className="my-1">
                          <Field
                            name="template"
                            type="radio"
                            component={RadioField}
                            label="Bulletin Style Chat"
                            value="2"
                            onChange={(event, value) =>
                              updateInboxSetup({
                                ...inboxSetup,
                                template_id: value,
                              })
                            }
                          />
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">
                      <Row className="mt-2">
                        <Col>
                          <i
                            className="mdi mdi-bell font-size-24 me-1"
                            style={{ verticalAlign: "middle" }}
                          />
                          <label style={{ fontSize: "14px" }}>
                            Notifications:{" "}
                          </label>
                        </Col>
                      </Row>
                    </th>
                    <td></td>
                    <td>
                      <Row className="mt-2">
                        <Col className="mt-2">Screen Name:</Col>
                        <Col xs="auto">
                          <Field
                            name="notificationsText"
                            component={TextField}
                            validate={[required]}
                          />
                        </Col>
                      </Row>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
          <BottomNavigation handleBack={handleBack} handleSave={onSave} />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          onSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.LIST_SCREEN)

const mapStateToProps = state => ({
  formValues: selector(state, "bottomMenu"),
  inboxSetup: state.ListScreen.inboxSetup,
  isDirty: isDirty(FORM_NAMES.LIST_SCREEN)(state, ...["bottomMenu"]),
  listScreenSetup: state.ListScreen.listScreenSetup,
  vendorConfig: state.clients.vendorConfig,
})

const mapDispatchToProps = dispatch => ({
  updateInboxSetup: values => dispatch(updateInboxSetup(values)),
  resetForm: () => dispatch(reset(FORM_NAMES.LIST_SCREEN)),
  updateListScreenSetup: values => dispatch(updateListScreenSetup(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BottomMenuTab)
